// extracted by mini-css-extract-plugin
export default {"top":"AttendenceHeader_top__ygC23","box":"AttendenceHeader_box__z84Gi","addButton":"AttendenceHeader_addButton__Eh7qw"};